import React from "react";
import Link from "../Link";
import "./ExpandRRIFButton.css";

const ExpandRRIFButton = () => {

    return (
        <Link href="/rrif-page">
            <div className="rectangle-4 border-1px-athens-gray-2">
                <div className="expand-rrif-button">
                    <div className="expand-rrif-button-5">
                        <div className="rrif-text">
                            <div className="rrif-text-1 nunito-bold-blue-20px">RRIF</div>
                        </div>
                    </div> 
                </div>
            </div>
        </Link>
    );
}

export default ExpandRRIFButton;